import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import nlTranslations from './nl.json';
import frTranslations from './fr.json';

const getLanguage = () => {
    const supportedLanguages = ['nl', 'fr'];
    const languageFromUrl = location.pathname.substring(1, 3);

    if (supportedLanguages.includes(languageFromUrl)) {
        localStorage.setItem('lng', languageFromUrl);

        return languageFromUrl;
    }

    return 'nl';
};

export const i18next = i18n.use(initReactI18next).init({
    lng: getLanguage(),
    resources: {
        nl: {
            translation: nlTranslations,
        },
        fr: {
            translation: frTranslations,
        },
    },
    debug: process.env.NODE_ENV === 'development',
});
